import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const UserIcon = (props: Props) => {
    const { color = 'white', width = 28, height = 28, ...rest } = props;

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <circle cx="14.0002" cy="8.91817" r="3.98849" stroke={color} strokeWidth="1.5" />

            <path
                d="M23.1953 23.3201H23.9453V23.3201L23.1953 23.3201ZM23.1953 23.8201V24.5701H23.9453V23.8201H23.1953ZM4.80469 23.8201H4.05469V24.5701H4.80469V23.8201ZM4.80469 23.3201L4.05469 23.3201V23.3201H4.80469ZM15.8926 15.9285V16.6785C19.8445 16.6785 22.4453 20.0051 22.4453 23.3201L23.1953 23.3201L23.9453 23.3201C23.9452 19.3041 20.7949 15.1785 15.8926 15.1785V15.9285ZM23.1953 23.3201H22.4453V23.8201H23.1953H23.9453V23.3201H23.1953ZM23.1953 23.8201V23.0701H4.80469V23.8201V24.5701H23.1953V23.8201ZM4.80469 23.8201H5.55469V23.3201H4.80469H4.05469V23.8201H4.80469ZM4.80469 23.3201L5.55469 23.3201C5.55475 20.0051 8.15548 16.6785 12.1074 16.6785V15.9285V15.1785C7.20514 15.1785 4.05476 19.3041 4.05469 23.3201L4.80469 23.3201ZM12.1074 15.9285V16.6785H15.8926V15.9285V15.1785H12.1074V15.9285Z"
                fill={color}
            />
        </svg>
    );
};
